// FileUploaderRipik.tsx

import React, { useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Button } from "@mui/material";
import SnackbarWithMessage from "../../../common/components/Snackbars/SnackbarWithMessage";

// interface FileUploaderProps {
//   file: File | null;
//   name: string;
//   file_update_function: (file: File) => void;
// }

export const FileUploaderRipik
  // : React.FC<FileUploaderProps>
  = ({ file, file_update_function, upload_message = "Upload File Here" }) => {
    const MAX_SIZE = 5000000;
    const { getRootProps, getInputProps, isDragActive, acceptedFiles, fileRejections } = useDropzone({
      maxFiles: 1,
      maxSize: MAX_SIZE
    });

    const [error_message, set_error_message] = useState(null);

    useEffect(() => {
      if (acceptedFiles && acceptedFiles[0]) {
        file_update_function(acceptedFiles[0]);
        // console.log(acceptedFiles);
        set_error_message(null);
      }
      if (fileRejections) {
        // console.log(fileRejections);
        if (fileRejections && fileRejections[0] && fileRejections[0].errors) {
          set_error_message(fileRejections[0].errors[0].message);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [acceptedFiles, fileRejections]);

    const timer = useRef(null);

    useEffect(() => {
      if (error_message !== null) {
        if (timer.current) {
          clearTimeout(timer.current);
        }
        timer.current = setTimeout(() => {
          set_error_message(null);
        }, 2500);
      }
      if (timer.current) {
        clearTimeout(timer.current);
      }
      return () => {
        if (timer.current) {
          clearTimeout(timer.current);
        }
      };
    }, [error_message]);


    return (
      <div
        className={`border-dashed border ${isDragActive ? "animate-blink" : "border-[#00000040]"} rounded ${error_message ? "border border-red-500" : ""}`}
        style={{
          width: "100%",
          // border: "1px solid red"
        }}
        {...getRootProps()}
      >
        {
          error_message &&
          <SnackbarWithMessage
            message={error_message}
            open={error_message && true}
            severity="error"
            onClose={() => {
              set_error_message(null);
            }}
          />
        }
        <input {...getInputProps()} />
        <Button variant="text" className={`w-full`} sx={{
          color: error_message ? "rgb(239, 68, 68)" : "inherit"
        }}>
          {isDragActive ? "Drop to upload." : file ? `File uploaded` : error_message ? error_message : upload_message}
        </Button>
      </div>
    );
  };
